import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TamasAlunoService } from '../tamas-aluno.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {Location} from '@angular/common';
import * as moment from 'moment';
import { BasePlanos, BasicoPaciente, BaseAvaliacao } from '../tamas-models';



@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrls: ['./dashboard-home.component.css']
})

export class DashboardHomeComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  arrUltimos: BasicoPaciente[] = [];
  arrPrescricoes: BasePlanos[] = [];
  arrAvaliacoes: BaseAvaliacao[] = [];
  displayedColumns: string[] = ['nome','cidade', 'dataf'];
  dataSource: BasicoPaciente[] = [];
  myselfId: any = 0;
  urlFoto: any = '';
  //dataSource = ELEMENT_DATA;

  constructor(public tmaService: TamasAlunoService,public router: Router,  public dialog: MatDialog, private _location: Location) { }


  ngOnInit() {
    this.hideCL = true;
    this.tmaService.eventoFS(true);
    this.getUltPacientes();
    this.getUltPrescricoes();
    this.getUltAvaliacoes();
    //this.myselfId = this.tmaService.hcNomeUsuario
    this.myselfId = 4;
  }
  ngOnDestroy(){
    this.tmaService.eventoFS(false);
  }

  getUltPacientes() :void{
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getUltimosP(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.arrUltimos = qRes['objResultado'];
        this.arrUltimos.forEach(element => {
          element.dataf =  moment(element.data).format('DD/MM/YYYY');
        });
        //this.dataSource =this.arrUltimos;
        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        //this.urlFoto = "https://apptamas.melhorpedida.com/fotosusuarios/";
      }
      else{

        if(qRes['res'] == 'invalid'){

         this.erroCredenciais();
        }
        if(qRes.length == 0){
          this.erroConsulta();
        }
      }
    },
    (error) =>{
      this.erroAPI();
    })
  }


  getUltPrescricoes() :void{
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&meuindex=0';
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getUltimasPre(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.arrPrescricoes = this.arrPrescricoes.concat(qRes['objDietas']);
        this.arrPrescricoes = this.arrPrescricoes.concat(qRes['objTreinos']);
        
        this.arrPrescricoes.forEach(element => {
          if(element.DataRetorno != null){
            element.DataRetorno =  moment(element.DataRetorno).format('DD/MM/YYYY');
          }

          if(element.DataTermino != null){
            element.DataTermino =  moment(element.DataTermino).format('DD/MM/YYYY');
          }

          element.DataCriado =  moment(element.DataCriado).format('DD/MM/YYYY');
          element.DataInicio =  moment(element.DataInicio).format('DD/MM/YYYY');
        });

        // this.arrPrescricoes.forEach(element => {
        //   element.dataf =  moment(element.data).format('DD/MM/YYYY');
        // });
        // this.dataSource =this.arrUltimos;
      }
      else{

        if(qRes['res'] == 'invalid'){

         this.erroCredenciais();
        }
        if(qRes.length == 0){
          this.erroConsulta();
        }
      }
    },
    (error) =>{
      this.erroAPI();
    })
  }


  getUltAvaliacoes() :void{
    this.hideCL = false;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&meuindex=0';
    //var gDados = 'txtpesquisa=' + this.qBuscado + '&email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha;
    this.tmaService.getUltimasAval(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.arrAvaliacoes = qRes['objResultado'];
        this.arrAvaliacoes.forEach(element => {
          element.DataAvaliacao =  moment(element.DataAvaliacao).format('DD/MM/YYYY');
        });
        // this.arrPrescricoes.forEach(element => {
        //   element.dataf =  moment(element.data).format('DD/MM/YYYY');
        // });
        // this.dataSource =this.arrUltimos;
      }
      else{

        if(qRes['res'] == 'invalid'){

         this.erroCredenciais();
        }
        if(qRes.length == 0){
          this.erroConsulta();
        }
      }
    },
    (error) =>{
      this.erroAPI();
    })
  }

  erroCredenciais() :void{
    const avisoErro =  this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {tituloAlerta: "Aviso",  textoAlerta: "Ocorreu um erro com suas credenciais, por favor efetue o login novamente", textoConfirm: "OK"}
    });
    avisoErro.afterClosed().subscribe((result) =>{
      if(this.tmaService.forceLogout().valueOf() == true){
        this.router.navigate(['/autenticar']);
      }
    });
  }

  erroConsulta() :void{
    const avisoErro =  this.dialog.open(AlertaConfirmDialog, {
      disableClose: true,
      data: {tituloAlerta: "Aviso",  textoAlerta: "Verifique sua conexão com a internet. Tente novamente", textoCancel: "Voltar", textoConfirm: "Tentar Novamente"}
    });
    avisoErro.afterClosed().subscribe((result) =>{
      if(result == true){
        this.ngOnInit();
      }
      else{
        this.voltar();
      }
    });
  }

  erroAPI() :void{
    this.hideCL = true;
    const avisoErro =  this.dialog.open(AlertaConfirmDialog, {
      // width: '250px',
      disableClose: true,
      data: {tituloAlerta: "Aviso",  textoAlerta: "Verifique sua conexão com a internet. Tente novamente", textoCancel: "Voltar", textoConfirm: "Tentar Novamente"}
    });
    avisoErro.afterClosed().subscribe((result) =>{
      if(result == true){
        this.ngOnInit();
      }
      else{
        this.voltar();
      }
    });
  }
  
  goPacientes() :void{
    this.router.navigate(['/dashboard/pacientes/all/all']);
  }

  goMyself() :void{
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/dashboard/paciente/' + this.tmaService.hcUid]);
  }
  goPaciente(idpaciente : any) :void{
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/dashboard/paciente/' + idpaciente]);
  }

  goPrescricao(idpaciente: any, idpresc: any, tipo: any) :void{
    console.log(tipo);
    if(tipo == undefined ){
      //'dashboard/refeicao/1/26'
      this.tmaService.gUrlAnterior = this.router.url;
      this.router.navigate(['/dashboard/refeicao/' + idpaciente + '/' + idpresc]);
    }
    else{
      this.tmaService.gUrlAnterior = this.router.url;
      this.router.navigate(['/dashboard/add-treino/' + idpaciente + '/' + idpresc]);
    }
    
  }
  
  goAvaliacao(idpaciente: any, idaval: any) :void{
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/dashboard/paciente/' + idpaciente + '/avaliacao/' + idaval]);
  }

  pesquisarPaciente()  :void{
    const addNT = this.dialog.open(AlertaInputDialog, {
      width: '250px',
      disableClose: true,
      data: {iconAlerta: "", textoInput: 'Nome', tipoInput: 'text', nomeInput: 'nome',  tituloAlerta: 'Pesquisar', textoAlerta: 'Digite o nome do paciente', textoCancel: 'Cancelar', textoConfirm: "OK"}
    });
    addNT.afterClosed().subscribe(result =>{
      console.log(result);
      if(result !== false && result !== undefined){

        if(result.length <= 3){
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose:true,
            data: {textoAlerta: "Digite pelo menos 4 caracteres para realizar a busca", iconAlerta: 'warning'}
          });
        }
        else{
          this.router.navigate(['/dashboard/pacientes/listar/' + result]);
        }

      }
    })
  }

  goNPaciente() :void{
    this.router.navigate(['/dashboard/novo-paciente']);
  }

  voltar(): void{
    //this._location.back();
    this.router.navigate(['/home' ]);
  }

}
